export const aciDayNight = {
    iconName: 'day-night',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 24 24' },
        path: {
            attr: {
                'fill-rule': 'evenodd',
                'clip-rule': 'evenodd',
                d: 'M12.5.75a.75.75 0 00-1.5 0v.75a.75.75 0 001.5 0V.75zm6.78 4.375l.845-.845a.75.75 0 00-1.06-1.06l-.845.845a.75.75 0 001.06 1.06zM21 11.75a.75.75 0 01.75-.75h.75a.75.75 0 010 1.5h-.75a.75.75 0 01-.75-.75zm-1.72 6.47a.75.75 0 10-1.06 1.06l.53.53a.75.75 0 101.06-1.06l-.53-.53zM11.75 21a.75.75 0 01.75.75v.75a.75.75 0 01-1.5 0v-.75a.75.75 0 01.75-.75zm-5.94-1.72a.75.75 0 10-1.06-1.06l-.53.53a.75.75 0 101.06 1.06l.53-.53zM0 11.75A.75.75 0 01.75 11h.75a.75.75 0 010 1.5H.75a.75.75 0 01-.75-.75zm5.28-7.53a.75.75 0 00-1.06 1.06l.53.53c.11.11.247.18.39.207a8.75 8.75 0 10.877-.877.747.747 0 00-.207-.39l-.53-.53zm5.626.329a7.251 7.251 0 103.8 13.823c-5.9-1.66-7.893-9.292-3.8-13.823zm5.763 12.527l-1.074-.223c-5.367-1.113-7.07-8.2-2.833-11.795l-.421-.534a7.25 7.25 0 014.328 12.552z',
                fill: 'currentColor',
            },
        },
    },
};
